import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import { AuthProvider } from "@/contexts/AuthContext";
import { BrandProvider } from "@/contexts/BrandContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import SolanaProviders from "@/components/SolanaProviders";
import Landing from "@/pages/Landing";
import JobsFeed from "@/pages/JobsFeed";
import JobDetail from "@/pages/JobDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Checkout from "@/pages/Checkout";
import Foundry from "@/pages/Foundry";
import About from "@/pages/About";
import Vision from "@/pages/Vision";
import FoundryInterview from "@/pages/FoundryInterview";
import MissionIntake from "@/pages/MissionIntake";
import AdminBoarders from "@/pages/AdminBoarders";
import PostMission from "@/pages/PostMission";
import Star from "@/pages/Star";

function Layout() {
    return (
        <div className="App min-h-screen">
            <Header />
            <main><Outlet /></main>
            <footer className="mt-24 border-t border-white/5 py-10">
                <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-3 px-6 text-xs text-[#737373] md:flex-row md:px-10">
                    <span>© {new Date().getFullYear()} Sovereign Recruitment & White-Label Hub</span>
                    <span className="caption">Confidential · Curated · Bonded</span>
                </div>
            </footer>
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <BrandProvider>
                <AuthProvider>
                    <SolanaProviders>
                        <Toaster theme="dark" position="top-right" richColors />
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Foundry />} />
                            <Route path="/foundry" element={<Foundry />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/vision" element={<Vision />} />
                            <Route path="/foundry/interview" element={<FoundryInterview />} />
                            <Route
                                path="/foundry/mission-intake"
                                element={
                                    <ProtectedRoute>
                                        <MissionIntake />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/boarders"
                                element={
                                    <ProtectedRoute>
                                        <AdminBoarders />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/star" element={<Star />} />
                            <Route path="/recruitment" element={<Landing />} />
                            <Route
                                path="/exchange"
                                element={<JobsFeed />}
                            />
                            <Route
                                path="/exchange/:id"
                                element={<JobDetail />}
                            />
                            <Route path="/exchange/post" element={<PostMission />} />
                            <Route path="/jobs" element={<JobsFeed />} />
                            <Route path="/jobs/:id" element={<JobDetail />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/checkout"
                                element={
                                    <ProtectedRoute>
                                        <Checkout />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<NotFound />} />
                        </Route>
                    </Routes>
                    </SolanaProviders>
                </AuthProvider>
            </BrandProvider>
        </BrowserRouter>
    );
}

function NotFound() {
    return (
        <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-6 text-center">
            <div className="caption text-[var(--brand-accent)]">404</div>
            <h1 className="mt-3 font-serif text-5xl tracking-display text-[#FAFAFA]">Not found</h1>
            <p className="mt-3 text-sm text-[#A3A3A3]">The page you're looking for doesn't exist.</p>
        </div>
    );
}

export default App;
